export default __webpack_public_path__ + "static/media/block.7a27ce44.svg";